var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFollow = function SvgIconFollow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "inherit"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_691_6992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.001 21.5a1 1 0 0 1-.71-.29l-7.77-7.78a5.26 5.26 0 0 1 0-7.4 5.24 5.24 0 0 1 7.4 0l1.08 1.08 1.08-1.08a5.24 5.24 0 0 1 7.4 0 5.26 5.26 0 0 1 0 7.4l-7.77 7.78a1 1 0 0 1-.71.29"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "inherit",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3.806 5.707a4.8 4.8 0 0 1 6.788 0L12 7.112l1.406-1.405a4.8 4.8 0 1 1 6.788 6.787L12 20.689l-8.194-8.195a4.8 4.8 0 0 1 0-6.787Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_691_6992"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h24v24H0z"
  })))));
};
export default SvgIconFollow;